import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PassengerRulesService {

  constructor() { 
    this.setBlankKeysToNull;
  }
  
  setBlankKeysToNull(passengerRules: any): any {
    if (!passengerRules || (Array.isArray(passengerRules) && passengerRules.length === 0)) return false; 
    let hasValidRule = false; 
    for (const key of Object.keys(passengerRules)) {
      const rule = passengerRules[key];
      let hasTrueValue = Object.values(rule).some(value => value === true); // Check for true values
      for (const ruleKey of Object.keys(rule)) {
        rule[ruleKey] = rule[ruleKey] === true ? rule[ruleKey] : null; // Set to null if not true
      }
      passengerRules[key] = hasTrueValue ? rule : null; // Set entire rule to null if no true values
      hasValidRule ||= hasTrueValue; // Update hasValidRule
    }
    return hasValidRule; 
  }
  

}
